import {
  useAgentChatContext,
  useAppConstantsContext,
} from '@ltvco/refresh-lib/ctx';
import {
  AgentChatLauncher,
  VetterAgentChatDrawer,
  useSession,
  useVehicleVetter,
} from '@ltvco/refresh-lib/v2';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const AgentChatSurface = () => {
  const {
    session: { account },
  } = useSession();
  const { isOpen, vehicle, openChat, closeChat } = useAgentChatContext();
  const {
    featureFlags: { hasCarVettingEnabled },
  } = useAppConstantsContext();
  const { pathname } = useLocation();

  const userId = account?.account?.user_info?.user_code ?? '';

  // Lifted so the vehicle-vetter session survives drawer open/close.
  const vetter = useVehicleVetter(userId);

  // Close the chat whenever the user navigates to a different page.
  // closeChat is idempotent so calling it while already closed is safe.
  useEffect(() => {
    closeChat();
  }, [pathname, closeChat]);

  const handleLauncherClick = useCallback(() => openChat(), [openChat]);

  if (!userId || !hasCarVettingEnabled) {
    return null;
  }

  return (
    <>
      {vehicle !== null && <AgentChatLauncher onClick={handleLauncherClick} />}
      <VetterAgentChatDrawer
        open={isOpen}
        onClose={closeChat}
        vetter={vetter}
        vehicleIdentifier={vehicle?.vehicleIdentifier}
        vehicleTitle={vehicle?.vehicleTitle}
      />
    </>
  );
};
